import { grey500 } from 'material-ui/styles/colors';

import pallet from 'constants/colors';

export default {
  infoList: {
    display: 'flex',
    flexDirection: 'column',
  },
  infoButton: {
    padding: 0,
    width: 24,
    height: 24,
  },
  root: {
    width: '100%',
  },
  result: {
    marginTop: 16,
    padding: 0,
  },
  message: {
    textAlign: 'center',
    padding: 24,
    textTransform: 'uppercase',
    fontWeight: 500,
    color: grey500,
  },
  errorMessage: {
    textAlign: 'center',
    padding: 24,
    textTransform: 'uppercase',
    fontWeight: 500,
    color: pallet.errorColor,
  },
  avatar: {
    objectFit: 'cover',
    objectPosition: '50% 30%',
  },
  secondaryText: {
    verticalAlign: 'bottom',
    margin: 0,
    color: 'inherit',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};



// WEBPACK FOOTER //
// ./src/styles/EmployeeSearch.js